/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Safety_DescriptionInputs */



/**
* | output |
* | --- |
* | "You're about to visit an external website." |
*
* @param {Link_Safety_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const link_safety_description = /** @type {((inputs?: Link_Safety_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Safety_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie sind dabei, eine externe Website zu besuchen.")
	return /** @type {LocalizedString} */ ("You're about to visit an external website.")
});